/* Hanky Planty — Quick view modal. Reuses the global [data-hp-add] AJAX handler in hp-theme.js. */
(function(){
  if(window.__hpQuickViewInit){return;} window.__hpQuickViewInit=true;

  function money(c){ if(c==null||isNaN(c)){return '';} var v=c/100; var s=(v%1===0)?v.toFixed(0):v.toFixed(2); return 'RM'+s; }

  function close(){ var o=document.getElementById('hp-qv-overlay'); if(o){ o.classList.remove('is-in'); setTimeout(function(){ if(o.parentNode){o.parentNode.removeChild(o);} },200); } }

  function build(p){
    close();
    var imgs=(p.images&&p.images.length)?p.images:(p.featured_image?[p.featured_image]:[]);
    var firstImg=imgs[0]||'';
    var variants=p.variants||[];
    var multi=variants.length>1;
    var v0=null,i;
    for(i=0;i<variants.length;i++){ if(variants[i].available){ v0=variants[i]; break; } }
    if(!v0){ v0=variants[0]; }
    var cmp=p.compare_at_price||p.compare_at_price_max||0;
    var onSale=cmp>p.price;
    var priceHtml=(onSale?'<s>'+money(cmp)+'</s> ':'')+money(p.price);
    var variantSel='';
    if(multi){
      var opts='';
      for(i=0;i<variants.length;i++){ var v=variants[i];
        opts+='<option value="'+v.id+'" data-price="'+v.price+'" data-compare="'+(v.compare_at_price||0)+'" '+(v.available?'':'disabled')+(v===v0?' selected':'')+'>'+v.title+(v.available?'':' — Sold out')+'</option>';
      }
      variantSel='<select class="hp-qv__variants" data-hp-qv-select>'+opts+'</select>';
    }
    var canBuy=(v0&&v0.available);
    var ov=document.createElement('div'); ov.id='hp-qv-overlay'; ov.className='hp-qv-overlay';
    ov.innerHTML='<div class="hp-qv"><button class="hp-qv__close" data-hp-qv-close aria-label="Close">×</button>'
      +'<div class="hp-qv__media"><img src="'+firstImg+'" alt="'+(p.title||'')+'"></div>'
      +'<div class="hp-qv__info">'
      +(p.type?'<div class="hp-qv__cat">'+p.type+'</div>':'')
      +'<h3 class="hp-qv__title">'+(p.title||'')+'</h3>'
      +'<div class="hp-qv__price" data-hp-qv-price>'+priceHtml+'</div>'
      +variantSel
      +'<button class="hp-qv__add" data-hp-add="'+(v0?v0.id:'')+'" '+(canBuy?'':'disabled')+'>'+(canBuy?'Add to cart':'Sold out')+'</button>'
      +'<a class="hp-qv__full" href="'+p.url+'">View full details</a>'
      +(p.description?'<div class="hp-qv__desc">'+p.description+'</div>':'')
      +'</div></div>';
    document.body.appendChild(ov);
    void ov.offsetWidth; ov.classList.add('is-in');
    ov.addEventListener('click',function(e){ if(e.target===ov||(e.target.closest&&e.target.closest('[data-hp-qv-close]'))){ close(); } });
    var sel=ov.querySelector('[data-hp-qv-select]');
    if(sel){ sel.addEventListener('change',function(){
      var opt=sel.options[sel.selectedIndex];
      var price=parseInt(opt.getAttribute('data-price'),10);
      var compare=parseInt(opt.getAttribute('data-compare'),10)||0;
      var pr=ov.querySelector('[data-hp-qv-price]'); if(pr){ pr.innerHTML=(compare>price?'<s>'+money(compare)+'</s> ':'')+money(price); }
      var add=ov.querySelector('.hp-qv__add');
      add.setAttribute('data-hp-add',sel.value);
      if(opt.disabled){ add.setAttribute('disabled','disabled'); add.textContent='Sold out'; }
      else{ add.removeAttribute('disabled'); add.textContent='Add to cart'; }
    }); }
  }

  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-hp-quickview]'); if(!t){return;}
    e.preventDefault(); e.stopPropagation();
    var handle=t.getAttribute('data-hp-quickview');
    var root=(window.Shopify&&window.Shopify.routes)?window.Shopify.routes.root:'/';
    fetch(root+'products/'+handle+'.js').then(function(r){return r.json();}).then(build).catch(function(){});
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ close(); } });
})();
